module.exports = __webpack_public_path__ + "img/home_profile.58e80117.jpg";